// pages/PrivacyPolicy.jsx
import React from "react";
import { useSEO } from "../../hooks/useSEO";
import Layout from "../../components/Layout";
import PageHeader from "../../components/ui/PageHeader";
import SectionRenderer from "../../components/ui/SectionRenderer";
import privacyData from "../../data/privacyPolicyData.json";
import { useTheme } from "../../theme/ThemeProvider";
import { PRIVACY_ROUTE } from "../../routes/constant";

const PrivacyPolicy = () => {
  const { isDarkMode } = useTheme();
  const { breadcrumb, header, sections } = privacyData;

  const breadcrumbItems = [
    {
      label: breadcrumb.home.label,
      path: breadcrumb.home.path,
      icon: breadcrumb.home.icon,
    },
  ];

  const currentPage = {
    label: breadcrumb.current.label,
    path: breadcrumb.current.path,
  };

  // Use SEO hook
  useSEO(PRIVACY_ROUTE);

  return (
    <Layout>
      <PageHeader
        title={header.title}
        breadcrumbItems={breadcrumbItems}
        currentPage={currentPage}
      />

      <div className={`transition-colors duration-200 ${
        isDarkMode ? "bg-gray-900" : "bg-white"
      }`}>
        <div className={`px-4 py-5 mx-auto max-w-7xl md:px-6 3xl:px-0 transition-colors duration-200 ${
          isDarkMode ? "bg-gray-900" : "bg-white"
        }`}>
          <div className={`p-4 transition-colors duration-200 ${
            isDarkMode 
              ? "bg-gray-800 text-gray-300" 
              : "bg-white text-gray-700"
          }`}>
            {sections.map((section, index) => (
              <SectionRenderer key={index} section={section} />
            ))}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default PrivacyPolicy;